module.exports = __webpack_public_path__ + "img/esc_4_act_4.bed965e4.png";